/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.news.service.ts.
 */
import {Injectable} from '@angular/core';
import {AppConfigService} from './app.config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {NewsEntry} from '../models/news_entry';
import {map} from 'rxjs/operators';
import {NewsEntryTag} from '../models/news-entry-tag';
import {PagedResult} from '../models/pagedresult';
import {NewsEntryFile} from '../models/news-entry-file';

/**
 * Zweck: Beschreibt class AppNewsService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppNewsService {
/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private cfg: AppConfigService, private http: HttpClient) {
  }

/**
 * Beschreibt Methode get und ihren Rückgabevertrag.
 */
  get(limit: number, tags: string[]): Observable<PagedResult<NewsEntry>> {
    return this.http.post<PagedResult<NewsEntry>>(
      '/news/get', {
        limit: limit,
        tags: tags
      }
    ).pipe(map(es => {
      es.data.forEach(e => {
        Object.setPrototypeOf(e, NewsEntry.prototype);
      });
      return es;
    }));
  }

/**
 * Beschreibt Methode getById und ihren Rückgabevertrag.
 */
  getById(id: number): Observable<NewsEntry> {
    return this.http.get<NewsEntry>(
      '/news/get/' + id
    ).pipe(map(e => {
      if (e) {
        Object.setPrototypeOf(e, NewsEntry.prototype);
      }
      return e;
    }));
  }

/**
 * Beschreibt Methode getNewsEntryFile und ihren Rückgabevertrag.
 */
  getNewsEntryFile(entry: NewsEntry, file: NewsEntryFile) {
    const options = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders().set('Content-Type', file.mime_type)
    };

    return this.http.get<any>(
      '/news/attachment/' + entry.id + '/' + file.id + '/' + file.label,
      options
    ).pipe(map(res => {
      // trick to download store a file having its URL
      const fileURL = URL.createObjectURL(res);
      const a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = file.label;
      document.body.appendChild(a);
      a.click();

      return true;
    }));
  }

/**
 * Beschreibt Methode setSeen und ihren Rückgabevertrag.
 */
  setSeen(entry: NewsEntry): Observable<boolean> {
    return this.http.get<boolean>(
      '/news/' + entry.id.toString() + '/seen'
    );
  }

/**
 * Beschreibt Methode toggleLike und ihren Rückgabevertrag.
 */
  toggleLike(entry: NewsEntry): Observable<{ ilike: boolean, likes: number }> {
    return this.http.get<{ ilike: boolean, likes: number }>(
      '/news/' + entry.id.toString() + '/toggleLike'
    );
  }

/**
 * Beschreibt Methode getTags und ihren Rückgabevertrag.
 */
  getTags(): Observable<NewsEntryTag[]> {
    return this.http.get<NewsEntryTag[]>(
      '/news/tags'
    ).pipe(map(es => {
      es.forEach(e => {
        Object.setPrototypeOf(e, NewsEntryTag.prototype);
      });
      return es;
    }));
  }
}
